module.exports = __webpack_public_path__ + "01_veryshort_brown.5f5071cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_veryshort_brown.png
// module id = i4E1
// module chunks = 0